/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService";

const socalApi = {
  // 제품 주문(set goods order)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-goods
  salesGoodsOrder(params) {
    return httpService.post(`/sales/order/goods/${params.goodsId}`);
  },
  bordList(params) {
    // return httpService.get(`/board/list`, params);
    return httpService.get(`/board/list?identifier=${params.bid}`);
  },
  boardAuth(boardId) {
    return httpService.get(`/board/${boardId}/auth`);
  },
  fetchList(params, boardId) {
    return httpService.get(`/board/${boardId.toUpperCase()}/article`, params);
    // return httpService.get(`/board/SNS/article/list`,params)
  },
  //https://clpapi.tinkeredu.co.kr/board/SNS/article/fix/list
  fetchStaticList(boardId) {
    return httpService.get(`/board/${boardId.toUpperCase()}/article/fix/list`);
  },
  //https://clpapi.tinkeredu.co.kr/board/SNS/article?type=MINE
  fetchMyList(params) {
    return httpService.get(`/board/SNS/article`, params);
  },
  //http://54.251.23.221:8080/static/docs/account.html#resources-account-fetch-info
  fetchMember(params) {
    return httpService.get(`/membership/member`, params);
    // return httpService.get(`/board/SNS/article/list`,params)
  },

  // 최근 주문자 정보(Recent Order Information)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-orderer-info-recent
  salesOrdererRecent() {
    return httpService.get(`/sales/order/orderer/recent`);
  },

  // 구매 주문 조회(get purchase order)
  // https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-detail
  socialDetails(id, boardId) {
    return httpService.get("/board/" + boardId + "/article/" + id);
  },

  // 주문 상세(get order detail information)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-detail
  salesOrderResult(params) {
    return httpService.get(`/sales/order/${params.paymentId}`);
  },

  // 결제 요청(request payment)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-pay-request
  salesRequestPayment(params) {

    return httpService.post(`/sales/order/${params.orderId}/pay`, params);
  },

  // Credit 카드 목록 조회(get card list)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-fetch-page
  salesCreditcardList(params) {
    return httpService.get(`/sales/creditcard`);
  },

  // 카드 등록(regist card)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-register
  salesCreditcardInsert(params) {
    return httpService.post(`/sales/creditcard`, params);
  },

  // 카드 삭제(delete card)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-credit-card-remove
  salesCreditcardDelete(params) {
    return httpService.delete(`/sales/creditcard/${params.id}`);
  },

  // 은행 목록 조회(get bank list)
  //
  salesRefundBankList(params) {
    return httpService.get(`/codes/code/BANK_CODE`);
  },

  // 환불 요청(request refund)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-request
  selesRefundRequest(params) {
    return httpService.post(`/sales/refund`, params);
  },

  // 환불 요청 정보 수정(update refund information)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-information-change
  selesRefundUpdate(params) {
    return httpService.put(`/sales/refund`, params);
  },

  // 결제 방법 목록(get payment method list)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-installed-payment-method
  salesPaymentMethodList(params) {
    return httpService.get(`/sales/order/paymentmethod`);
  },

  // 구매목록(get purchase list)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-purchase-page
  salesOrderList(params) {
    return httpService.get(`/sales/order`, params);
  },

  // 주문 상세(get order detail information)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-fetch-detail
  salesOrderDetail(params) {
    return httpService.get(`/sales/order/${params.orderId}`);
  },

  // 환불 1:1 문의 조회(get refund FAQ list)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-board-fetch
  salesQnAList(params) {
    return httpService.get(`/sales/refund/board`, params);
  },

  // 환불 1:1 문의 등록(regist refund FAQ)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-refund-board-register
  salesQnAWrite(params) {
    return httpService.post(`/sales/refund/board`, params);
  },

  // Add post
  // https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-register
  register(params, boardId) {
    return httpService.post(`/board/${boardId}/article`, params);
  },

  // list all comment under a post
  // http://54.251.23.221:8080/static/docs/article_comment.html#resources-board-article-fetch
  listComments(articleId, params) {
    return httpService.get(`/board/SNS/article/${articleId}/comment`, params);
    // return httpService.get(`/board/SNS/article/${articleId}/comment`, params);
  },
  // add comment under a post
  commentPost(articleId, params, boardId) {
    return httpService.post(`/board/${boardId}/article/${articleId}/comment`, params);
  },
  // add comment under a post
  commentEdit(articleId, params, boardId, id) {
    return httpService.put(`/board/${boardId}/article/${articleId}/comment/${id}`, params);
  },
  // delete post
  deletePost(boardId, id) {
    return httpService.delete(`/board/${boardId}/article/${id}`)
  },

  patchPostDislike(boardId, id) {
    return httpService.post(`/board/${boardId}/article/${id}/likes`);
  },

  patchPostLike(boardId, id) {
    return httpService.delete(`/board/${boardId}/article/${id}/likes`);
  },

  reportPost(boardId, id) {
    return httpService.post(`/board/${boardId}/article/${id}/report`)
  },

  updatePost(id, params, boardId) {
    return httpService.put(`/board/${boardId}/article/${id}`, params);
  },

  searchTags(str) {
    return httpService.get(`/common/tag/search?name=${str}`);
  },

  createTags(str) {
    return httpService.post(`/common/tag`, str);
  },

  // 1Level OR 2Level Comment Like 
  likeComment(boardId, articleId, id) {
    return httpService.post(`/board/${boardId}/article/${articleId}/comment/${id}/likes`)
  },

  //  1Level OR 2Level Comment Like Cancel
  dislikeComment(boardId, articleId, id) {
    return httpService.delete(`/board/${boardId}/article/${articleId}/comment/${id}/likes`)
  },

  // 1Level OR 2Level Comment Report 
  reportComment(boardId, articleId, id) {
    return httpService.post(`/board/${boardId}/article/${articleId}/comment/${id}/report`)
  },

  // 1Level OR 2Level Comment Delete 
  deleteComment(boardId, articleId, id) {
    return httpService.delete(`/board/${boardId}/article/${articleId}/comment/${id}`)
  },

  // 2Level Comment Registration api
  postReply(boardId, articleId, originId, params) {
    return httpService.post(`/board/${boardId}/article/${articleId}/comment/${originId}`, params)
  },
  // 2Level Comment Registration api
  editReply(boardId, articleId, replyEditId, params) {
    return httpService.put(`/board/${boardId}/article/${articleId}/comment/${replyEditId}`, params)
  },

  upload(file) {
    let formData = new FormData();
    formData.append("file", file);
    return httpService.post("/common/attachment", formData)
  }
};

// export const
export default socalApi;